import { createSlice } from "@reduxjs/toolkit";

import type { ResultsReduxState } from "@app/types/results-redux-types";

import { getTripDetailsThunk } from "./thunks/get-trip-details";

export const TripDetailsFetchStatusKey = {
  Loading: "LOADING",
  Error: "ERROR",
  Done: "DONE"
} as const;

export type TripDetailsFetchStatus =
  (typeof TripDetailsFetchStatusKey)[keyof typeof TripDetailsFetchStatusKey];

const initial_state = {};

const should_load_conditions = [
  undefined,
  TripDetailsFetchStatusKey.Error,
  TripDetailsFetchStatusKey.Done
];

const TripDetailsFetchStatus = createSlice<
  ResultsReduxState["trip_details_fetch_status"],
  {}
>({
  name: "trip_details_fetch_status",
  initialState: initial_state,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getTripDetailsThunk.pending, (state, action) => {
        const { trip_id } = action.meta.arg;

        const should_load = should_load_conditions.includes(
          state[trip_id as keyof typeof state] as any
        );

        if (should_load) {
          state[trip_id] = TripDetailsFetchStatusKey.Loading;
        }
      })
      .addCase(getTripDetailsThunk.fulfilled, (state, action) => {
        const { trip_id } = action.meta.arg;

        if (state[trip_id] === TripDetailsFetchStatusKey.Loading) {
          state[trip_id] = TripDetailsFetchStatusKey.Done;
        }
      })
      .addCase(getTripDetailsThunk.rejected, (state, action) => {
        const { trip_id } = action.meta.arg;

        state[trip_id] = TripDetailsFetchStatusKey.Error;
      });
  }
});

export default TripDetailsFetchStatus.reducer;
